import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16047f12"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-col-centered" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_2 = { class: "top-content" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "grid-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "grid-item-left",
  for: "market"
}, "Market", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "grid-item-left",
  for: "contractId"
}, "Contract ID", -1))
const _hoisted_8 = { class: "grid-item-left" }
const _hoisted_9 = {
  class: "date-picker",
  style: {"width":"100%"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "grid-item-left",
  for: "caseReference"
}, "Case Reference ID", -1))
const _hoisted_11 = { class: "grid-item-left" }
const _hoisted_12 = { class: "grid-item-left" }
const _hoisted_13 = { class: "grid-item-left" }
const _hoisted_14 = { class: "grid-item-left" }
const _hoisted_15 = { class: "grid-item-left" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "grid-item-left",
  for: "comments"
}, "Comments", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-col-centered" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "submit-btn",
    type: "submit"
  }, " CONFIRM ")
], -1))

import { computed, ref } from "vue";
import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Popup from "./Popup.vue";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import ToolTipLabel from "@/components/ToolTipLabel.vue";
import CurrencyInput from "@/components/CurrencyInput.vue";
import { MarketCurrency } from "@/services/helpers/Helper";
import { insuranceClaims } from "@/services/network";
import IInsuranceForm from "@/Interfaces/InsuranceClaims/IInsuranceClaimsForm";
import {  MarketSelection } from '@/services/helpers/Helper';
import DateIgnoreTime from "@/types/DateIgnoreTime";
import { authService } from "@/auth/authSingleton";


export default /*#__PURE__*/_defineComponent({
  __name: 'InsuranceClaimsPopUp',
  props: {
    modelValue: { type: Boolean },
    market: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const markets = Object.entries(MarketSelection);
const insuranceFormRequest= ref<IInsuranceForm>({
    market: 'GB',
    contractId: "",
    userEmail: ""
});
const FormatDatePicker = (date: Date) => {
    return date.toLocaleString("sv-SE").split(" ")[0].replaceAll("-", "/");
};
const textInputOptions = { format: "yyyy/MM/dd" };
const props = __props;
const insurancePopUpStatus = computed({
    get() {
        if(props.modelValue == true){
            insuranceFormRequest.value.market = props.market as keyof typeof MarketSelection
            insuranceFormRequest.value.userEmail = authService.getEmailAddress()
        }
        return props.modelValue
    },
    set(val) {
        emits('update:modelValue', val);
    }
});
const emits = __emit;
const working = ref(false);
function closeChild(){
    insurancePopUpStatus.value = false;
    insuranceFormRequest.value = {} as IInsuranceForm;
}
const fullAmmountRequiredFields = ref(false)
function HandleFullAmountRequirementChange(event: Event): void{
    const target = event.target as HTMLInputElement;
    if(target.value != ""){
        fullAmmountRequiredFields.value = true
    }else{
        fullAmmountRequiredFields.value = false
    }
}
async function RaiseInsuranceClaim() {
    if(working.value) return;    
    const closeSpinner = useSpinnerPopup().show();
    try{
        if(insuranceFormRequest.value.paymentDate?.isValid()  && (insuranceFormRequest.value.fullAmount == null || insuranceFormRequest.value.fullAmount.toString() === '')){
            useNotifierWithErrFormatter().warn({msg: "When specifying 'Payment Date' remeber to specify 'Full Amount'"});
        }
        else{
            working.value=true
            let postRequest: IInsuranceForm = insuranceFormRequest.value;    
            postRequest.paymentDate = new DateIgnoreTime(postRequest.paymentDate)
            await insuranceClaims.post(postRequest)
            useNotifierWithErrFormatter().success({ msg: "Insurance Claim successfully registered." });
            emits("confirm");
            closeChild()
        }
    }catch(error){
        useNotifierWithErrFormatter().error({error});
    }
    closeSpinner()
    working.value=false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: insurancePopUpStatus.value,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((insurancePopUpStatus).value = $event)),
    title: "Create New Insurance Claim",
    hasClose: ""
  }, {
    contents: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(RaiseInsuranceClaim, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("select", {
              id: "market",
              class: "dropdown",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((insuranceFormRequest.value.market) = $event)),
              required: "",
              disabled: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(markets), ([market,display]) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: market,
                  key: market
                }, _toDisplayString(display), 9, _hoisted_6))
              }), 128))
            ], 512), [
              [_vModelSelect, insuranceFormRequest.value.market]
            ]),
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              class: "form-input invalid-input",
              type: "text",
              maxlength: "24",
              placeholder: "",
              id: "contractId",
              required: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((insuranceFormRequest.value.contractId) = $event))
            }, null, 512), [
              [_vModelText, insuranceFormRequest.value.contractId]
            ]),
            _createElementVNode("span", _hoisted_8, [
              _createVNode(ToolTipLabel, {
                warning: "",
                tip: "After inserting this value the only remaining editable field is comments",
                text: "Payment Date",
                forId: "datePicker"
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(DatePicker), {
                modelValue: insuranceFormRequest.value.paymentDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((insuranceFormRequest.value.paymentDate) = $event)),
                type: "date",
                "enable-time-picker": false,
                format: FormatDatePicker,
                placeholder: "Select Payment Date...",
                "text-input-options": textInputOptions,
                "text-input": "",
                "max-date": new Date(),
                teleport: true,
                onInput: HandleFullAmountRequirementChange,
                id: "datePicker",
                class: "invalid-input"
              }, null, 8, ["modelValue", "max-date"])
            ]),
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              class: "form-input invalid-input",
              type: "text",
              maxlength: "24",
              placeholder: "",
              id: "caseReference",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((insuranceFormRequest.value.caseReferenceId) = $event))
            }, null, 512), [
              [_vModelText, insuranceFormRequest.value.caseReferenceId]
            ]),
            _createElementVNode("span", _hoisted_11, [
              _createVNode(ToolTipLabel, {
                information: "",
                tip: "Full insurance payment amount excluding excess",
                text: "Full Amount",
                forId: "fullAmount"
              })
            ]),
            _createVNode(CurrencyInput, {
              modelValue: insuranceFormRequest.value.fullAmount,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((insuranceFormRequest.value.fullAmount) = $event)),
              min: 0.01,
              currency: _unref(MarketCurrency)[insuranceFormRequest.value.market],
              id: "fullAmount",
              required: fullAmmountRequiredFields.value,
              class: "invalid-input"
            }, null, 8, ["modelValue", "currency", "required"]),
            _createElementVNode("span", _hoisted_12, [
              _createVNode(ToolTipLabel, {
                information: "",
                tip: "Insurance company excess amount",
                text: "Excess Amount",
                forId: "excess"
              })
            ]),
            _createVNode(CurrencyInput, {
              modelValue: insuranceFormRequest.value.excessAmount,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((insuranceFormRequest.value.excessAmount) = $event)),
              min: 0,
              currency: _unref(MarketCurrency)[insuranceFormRequest.value.market],
              id: "excess",
              class: "invalid-input"
            }, null, 8, ["modelValue", "currency"]),
            _createElementVNode("span", _hoisted_13, [
              _createVNode(ToolTipLabel, {
                information: "",
                tip: "Name of the insurance company handling the case",
                text: "Company Name",
                forId: "companyName"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "form-input invalid-input",
              type: "text",
              maxlength: "30",
              id: "companyName",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((insuranceFormRequest.value.companyName) = $event))
            }, null, 512), [
              [_vModelText, insuranceFormRequest.value.companyName]
            ]),
            _createElementVNode("span", _hoisted_14, [
              _createVNode(ToolTipLabel, {
                information: "",
                tip: "VAT ID of the insurance company handling the case",
                text: "Company VAT ID",
                forId: "companyVat"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "form-input invalid-input",
              type: "text",
              maxlength: "30",
              id: "companyVat",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((insuranceFormRequest.value.companyVatId) = $event))
            }, null, 512), [
              [_vModelText, insuranceFormRequest.value.companyVatId]
            ]),
            _createElementVNode("span", _hoisted_15, [
              _createVNode(ToolTipLabel, {
                information: "",
                tip: "Location the insurance company handling the case",
                text: "Company Location",
                forId: "companyLocation"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "form-input invalid-input",
              type: "text",
              maxlength: "30",
              id: "companyLocation",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((insuranceFormRequest.value.companyLocation) = $event))
            }, null, 512), [
              [_vModelText, insuranceFormRequest.value.companyLocation]
            ]),
            _hoisted_16,
            _withDirectives(_createElementVNode("textarea", {
              class: "form-input textarea-input",
              maxlength: "4096",
              spellcheck: "true",
              rows: "4",
              id: "comments",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((insuranceFormRequest.value.comments) = $event))
            }, " ", 512), [
              [_vModelText, insuranceFormRequest.value.comments]
            ])
          ]),
          _hoisted_17
        ], 40, _hoisted_3)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})